export const text = {
  upload: "Upload New Document",
};
